import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils"

const buttonVariants = cva(
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0",
  {
    variants: {
      variant: {
        default: "bg-primary text-primary-foreground shadow-soft hover:opacity-90 transition-opacity duration-300",
        destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90 transition-colors duration-300",
        outline: "border border-input bg-background shadow-sm hover:bg-secondary hover:text-secondary-foreground transition-colors duration-300",
        secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80 transition-colors duration-300",
        ghost: "hover:bg-secondary hover:text-secondary-foreground transition-colors duration-300",
        link: "text-primary underline-offset-4 hover:underline transition-colors duration-300",
        premium: "bg-primary text-primary-foreground shadow-medium hover:shadow-elevated transition-shadow duration-300 rounded-lg",
        warm: "bg-accent text-accent-foreground shadow-medium hover:shadow-elevated transition-shadow duration-300 rounded-lg",
        hero: "bg-primary/5 text-primary border border-primary/20 hover:bg-primary/10 transition-colors duration-300 rounded-lg",
        "outline-primary": "border-2 border-primary text-primary bg-transparent hover:bg-primary hover:text-primary-foreground transition-colors duration-300 rounded-lg",
        "outline-accent": "border-2 border-accent text-accent bg-transparent hover:bg-accent hover:text-accent-foreground transition-colors duration-300 rounded-lg",
      },
      size: {
        default: "h-10 px-5 py-2",
        sm: "h-8 rounded-md px-3 text-xs",
        lg: "h-12 rounded-lg px-8 text-base",
        xl: "h-14 rounded-lg px-10 text-lg",
        icon: "h-9 w-9",
      },
    },
    defaultVariants: { variant: "default", size: "default" },
  }
)

const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "button"
  return <Comp className={cn(buttonVariants({ variant, size, className }))} ref={ref} {...props} />
})
Button.displayName = "Button"

export { Button, buttonVariants }
